import { render, staticRenderFns } from "./BlogDetailsPage.vue?vue&type=template&id=b38b3e3c&scoped=true"
import script from "./BlogDetailsPage.vue?vue&type=script&lang=js"
export * from "./BlogDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./BlogDetailsPage.vue?vue&type=style&index=0&id=b38b3e3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38b3e3c",
  null
  
)

export default component.exports